module.exports = __webpack_public_path__ + "img/howto-2.771f9223.png";